import script from "./BPTQuestionForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BPTQuestionForm.vue?vue&type=script&lang=ts&setup=true"

import "./BPTQuestionForm.vue?vue&type=style&index=0&id=33654564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33654564"]])

export default __exports__